import React from "react";
import { Zap, Smartphone, Shield, Eye } from "lucide-react";
import welcomeBanner from "@/assets/welcome-banner.jpg";
import session3Background from "../../assets/session3-background.jpg";

const CommitmentSection = () => {
    const commitments = [
        {
            icon: <Zap className="w-8 h-8" />,
            title: "Agilidade",
            description: "Tempo é importante para todos. Estamos constantemente trabalhando para atendê-lo da forma mais rápida possível trazendo como parceiros serviços de Cloud de alta performance."
        },
        {
            icon: <Smartphone className="w-8 h-8" />,
            title: "Facilidade",
            description: "Tenha acesso rápido e completo às informações que você precisa para tomar decisões estratégicas e impulsionar o seu negócio de qualquer lugar e a qualquer hora."
        },
        {
            icon: <Shield className="w-8 h-8" />,
            title: "Segurança",
            description: "Todos os dados trafegados são criptografados em uma conexão segura entre nossos servidores e nossos clientes."
        },
        {
            icon: <Eye className="w-8 h-8" />,
            title: "Transparência",
            description: "Nossa política de transparência garante aos nossos clientes acesso total às informações sobre seus projetos e serviços."
        }
    ];

    return (
        <section id="compromisso" className="relative py-20 overflow-hidden">
            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${session3Background})`
                }}
            ></div>

            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#0c1248]/90 to-[#0c1248]/75"></div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                        Compromisso da Manage4Me
                    </h2>
                    <p className="text-lg text-gray-200 max-w-2xl mx-auto">
                        Nossos valores fundamentais que orientam cada decisão e ação em prol do seu sucesso
                    </p>
                </div>

                {/* Commitments Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {commitments.map((commitment, index) => (
                        <div
                            key={index}
                            className="group bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl border border-white/20"
                        >
                            <div className="text-center space-y-4">
                                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-[#d03737] to-[#d03737]/80 rounded-2xl text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
                                    {commitment.icon}
                                </div>
                                <h3 className="text-xl font-bold text-white">
                                    {commitment.title}
                                </h3>
                                <p className="text-gray-200 leading-relaxed text-sm">
                                    {commitment.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom CTA */}
                <div className="text-center mt-16">
                    <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
            <span className="text-white font-medium">
              Conheça mais sobre nossos valores e compromissos
            </span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CommitmentSection;